export default __webpack_public_path__ + "static/media/mcrd.f68d5ae2.png";